import { useTranslation } from 'react-i18next'

import { Button, ButtonWithSpinner, Modal } from '@reveni-io/reveni-ui'

import DeleteReturnInstructionModalContent from './DeleteReturnInstructionModalContent/DeleteReturnInstructionModalContent'
import * as Styles from './styles'

const DeleteReturnInstructionModal = ({
  show,
  onClose,
  onDelete,
  associatedDeliveryMethods,
  deleting,
  availableReplacements,
  replacementId,
  onChangeReplacementId,
  isFormValid,
  loading,
}) => {
  const { t } = useTranslation()

  const handleReplacementChange = e => onChangeReplacementId(e.target.value)

  return (
    <Modal title={t('Eliminar instrucciones de devolución')} show={show} onClose={onClose} size="l">
      <Styles.MainContainer>
        <DeleteReturnInstructionModalContent
          loading={loading}
          associatedDeliveryMethods={associatedDeliveryMethods}
          replacementId={replacementId}
          availableReplacements={availableReplacements}
          onChangeReplacementId={handleReplacementChange}
        />
        <Styles.ActionsContainer>
          <Button variant="outlined" onClick={onClose} fullWidth>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            loading={deleting}
            disabled={loading || deleting || !isFormValid()}
            onClick={onDelete}
            defaultLabel={t('Confirmar y eliminar')}
            loadingLabel={t('Confirmar y eliminar')}
          />
        </Styles.ActionsContainer>
      </Styles.MainContainer>
    </Modal>
  )
}

export default DeleteReturnInstructionModal
